import React from 'react';
import './StatisticsTrustBar.css';

const StatisticsTrustBar = ({ todayApproved = 0, todayRefused = 0 }) => {
  const totalDecisions = todayApproved + todayRefused;
  const approvalRate = totalDecisions > 0 ? ((todayApproved / totalDecisions) * 100).toFixed(1) : null;

  const stats = [
    {
      icon: '🎯',
      label: 'Official Source',
      value: 'NDVO',
      suffix: '',
      highlight: true
    },
    {
      icon: '⚡',
      label: 'Monitoring',
      value: 'Automated',
      suffix: '',
      highlight: false
    },
    {
      icon: '📊',
      label: totalDecisions > 0 ? 'Latest outcome split' : 'Latest decisions',
      value: approvalRate || 'No data',
      suffix: approvalRate ? '%' : '',
      highlight: false
    },
    {
      icon: '🔒',
      label: 'Premium Planning Tools',
      value: '13',
      suffix: '',
      highlight: false
    }
  ];

  return (
    <div className="statistics-trust-bar">
      <div className="stats-container">
        {stats.map((stat, index) => (
          <div key={index} className={`stat-item ${stat.highlight ? 'stat-highlight' : ''}`}>
            <div className="stat-icon">{stat.icon}</div>
            <div className="stat-content">
              <div className="stat-value">
                {stat.value}
                <span className="stat-suffix">{stat.suffix}</span>
              </div>
              <div className="stat-label">{stat.label}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default StatisticsTrustBar;
